import 'swiper/css/navigation';

export default class Testimonials {
    constructor() {
        this.testimonials = document.querySelectorAll('.fd-block-testimoniaux');

        this.init();
    }

    init() {
        if(this.testimonials.length) {
            this.testimonials.forEach(() => {
                const testimonial = new Swiper('.fd-testimoniaux', {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    centeredSlides: false,
                    spaceBetween: 20,
                    grabCursor: true,
                    navigation: {
                        nextEl: '.fd-block-testimoniaux .swiper-next',
                        prevEl: '.fd-block-testimoniaux .swiper-prev',
                    },
                })
            })
        }
    }
}

